<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'Layout',
};
</script>

<style >
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.1s ease;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
</style>
